import React from "react";

function Footer() {
  return (
    <footer className="relative w-full  text-white overflow-hidden">
      {/* Subtle top border with gradient */}
      <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>

      {/* Grid background */}
      <div className="absolute inset-0 opacity-[0.015]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-16">
        {/* Main Content - Simplified */}
        <div className="flex flex-col items-center text-center space-y-6 mb-12">
          {/* Branding */}
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-lg bg-white/[0.03] border border-white/[0.08] 
                          flex items-center justify-center"
            >
              <span className="text-white/40 text-sm font-light">MJH</span>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-light text-white/70">
                Mohammed Junaid Hussain
              </h3>
            </div>
          </div>

          <p className="text-white/40 text-sm sm:text-sm font-light leading-relaxed max-w-md">
            Full-Stack Developer & ML Researcher
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/[0.04]">
          <div className="flex flex-col items-center gap-3 text-center">
            {/* Copyright */}
            <div className="flex items-center gap-2 text-white/30 text-xs font-light">
              <span>© {new Date().getFullYear()}</span>
              <span className="w-1 h-1 rounded-full bg-white/30"></span>
              <span>All rights reserved</span>
            </div>

            {/* Made with */}
            <div className="flex items-center gap-2 text-white/30 text-xs font-light">
              <span>Built with</span>
              <span className="text-white/40">React & Tailwind</span>
            </div>
          </div>
        </div>

        {/* Decorative Element */}
        <div className="mt-12 flex justify-center">
          <div className="flex items-center gap-2">
            <div className="w-12 h-[1px] bg-gradient-to-r from-transparent to-white/10"></div>
            <div className="w-1 h-1 rounded-full bg-white/20 animate-pulse"></div>
            <div className="w-12 h-[1px] bg-gradient-to-l from-transparent to-white/10"></div>
          </div>
        </div>
      </div>

      {/* Floating accent */}
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-white/[0.005] blur-[150px] rounded-full"></div>
    </footer>
  );
}

export default Footer;
